<template>
  <div>
    <div class="air__utils__heading mb-2">
      <h5>Approval Requests</h5>
    </div>
    <div class="row justify-content-center" v-if="pagepermission.viewable">
      <div class="col-xl-12">
        <div class="row align-items-center mb-2">
          <!-- Session Select -->
          <div class="col-md-2 col-12 mb-2">
            <a-select
              size="large"
              v-model="selectedSession"
              optionFilterProp="children"
              style="width: 100%"
              @change="handleSessionChange"
              :filterOption="false"
              :defaultValue="currentSession ? currentSession.id : ''"
            >
            <template v-for="schoolSession in schoolSessions">
              <a-select-option :value="schoolSession.id" :key="schoolSession.id">
                  {{schoolSession.name}}
                  <small class="text-primary ml-2">{{ currentSession.id === schoolSession.id ? 'Current' : '' }}</small>
              </a-select-option>
            </template>
            </a-select>
          </div>
          <!-- Class Select -->
          <div class="col-md-2 col-12 mb-2">
            <a-spin :spinning="classSpinning">
              <a-select
                size="large"
                v-model="selectedClass"
                placeholder="All Classes"
                optionFilterProp="children"
                style="width: 100%"
                @change="handleClassSelect"
                :filterOption="false"
                :defaultValue="undefined"
              >
                <a-select-option :value="undefined">All Classes</a-select-option>
                <template v-for="schoolClass in schoolClasses">
                  <a-select-option :value="schoolClass.id" :key="schoolClass.id">
                  {{schoolClass.name}}
                  </a-select-option>
                </template>
              </a-select>
            </a-spin>
          </div>
          <!-- Section Select -->
          <div class="col-md-2 col-12 mb-2">
            <a-spin :spinning="sectionSpinning">
              <a-select
              size="large"
                v-model="selectedSection"
                placeholder="All Sections"
                optionFilterProp="children"
                style="width: 100%"
                @change="handleSectionChange"
                :filterOption="false"
                :defaultValue="undefined"
                :disabled="!selectedClass"
              >
                <a-select-option :value="undefined">All Sections</a-select-option>
                <template v-for="section in sections">
                  <a-select-option :value="section.id" :key="section.id">
                  {{section.name}}
                  </a-select-option>
                </template>
              </a-select>
            </a-spin>
          </div>
          <!-- Date Range Picker -->
          <div class="col-md-3 col-12 mb-2">
            <a-range-picker
               v-model="selectedDate"
              size="large"
              style="width: 100%"
              :format="dateFormat"
              @change="handleDateSelect"
              :disabled="!selectedClass"
              :disabledDate="disabledDate"
              :placeholder="['Start Date', 'End Date']"
            />
          </div>
          <!-- Status Filter -->
          <div class="col-md-2 col-12 mb-2">
          <a-select
          size="large"
          v-model="selectedStatus"
          placeholder="Select Status"
          style="width: 100%"
          @change="handleStatusChange"
          allowClear
          >
          <a-select-option
          v-for="status in statusOptions"
          :key="status"
          :value="status"
          >
          {{ status }}
        </a-select-option>
        </a-select>
        </div>

          <!-- Student Search -->
          <!-- <div class="col-md-6 col-12 mb-2" v-if="!selectedRowKeys.length">
            <div class="text-right">
              <a-input-search
                placeholder="Search Students.."
                size="large"
                v-model="search"
                @search="searchStudents"
                @change="searchStudents"
              />
            </div>
          </div>
          <div class="col-md-6 col-12 mb-2 text-md-right" v-else-if="pagepermission.deletable" >
            <a href="javascript:;" class="btn btn btn-danger btn-with-addon"
              @click="handleDeleteSelected"
            >
              <span class="btn-addon">
                <i class="btn-addon-icon fe fe-trash" />
              </span>
              Delete Selected
            </a>
          </div> -->
        </div>
        <div class="card">
          <div class="card-body">
          <approval-table :rolesetting="pagepermission" ref="approvalTable" :data="data" :loading="loading" :session="selectedSession" :actionRequiredOptions="actionRequiredOptions"  @selectChange="handleTableSelect" @approve="handleApprove"/>
          </div>
        </div>
        <div class="text-right">
          <a-pagination
              showSizeChanger
              @showSizeChange="onShowSizeChange"
              :total="meta.total"
              :pageSize.sync="pageSize"
              v-model="current"
              @change="onChange"
            >
          </a-pagination>
        </div>
      </div>
      </div>
      <div class="row justify-content-center" v-else>
      <template>
        <div>
          <a-spin :spinning="permissionCheckSpinning">
            <p class="error" v-if="!permissionCheckSpinning">
              You don't have permission to use this feature.
            </p>
          </a-spin>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import ApprovalTable from '@/components/approval/Table/index.vue'
import { find } from 'lodash'
import moment from 'moment'
export default {
  name: 'ApprovalRequests',
  components: { ApprovalTable },
  beforeMount: function () {
    this.permissionCheckSpinning = true
    let rc = this.$roleutility.checkpermission('student', 22)
    rc.then(data => {
      console.log('RoleCheck!Data processed. ', data)
      this.pagepermission = data.pagePermission
      this.permissionCheckSpinning = false
    })
  },
  mounted: function() {
    this.$http.get('/api/session')
      .then(({ data }) => {
        this.schoolSessions = data.data
        this.selectedSession = find(data.data, ['is_current', 1]).id
        this.getClasses()
        this.fetchApprovalRequests()
      })
      .catch(error => {
        console.log(error)
        this.$neoNotify.error(error)
      })
  },
  created() {
    // this.searchStudents = debounce(this.searchStudents, 500)
  },
  computed: {
    currentSession: function() {
      const session = find(this.schoolSessions, ['is_current', 1])
      return session
    },
  },
  watch: {
    currentSession: function (val) {
      this.selectedSession = val.id
    },
  },
  data: function() {
    return {
      loading: true,
      visible: false,
      data: [],
      meta: {},
      actionRequiredOptions: [],
      schoolClasses: [],
      sections: [],
      schoolSessions: [],
      current: 1,
      pageSize: 20,
      selectedClass: undefined,
      selectedSection: undefined,
      selectedSession: undefined,
      sectionSpinning: false,
      classSpinning: false,
      disabledDates: [],
      dateFormat: 'DD-MM-YYYY',
      selectedDate: null,
      search: null,
      selectedRowKeys: [],
      pagepermission: {
        insertable: false,
        editable: false,
        viewable: false,
        deletable: false,
      },
      sorterField: null,
      sorterOrder: null,
      filters: [],
      selectedStatus: 'All Status',
      statusOptions: ['All Status', 'VERIFIED', 'APPROVED'],
      permissionCheckSpinning: true,
    }
  },
  methods: {
    handleTableSelect: function(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    // getStudents: function(isSearch) {
    //   this.selectedRowKeys = []
    //   this.loading = true

    //   let page = this.current
    //   if (isSearch) {
    //     page = 1
    //     this.current = 1
    //   }

    //   this.$http.get('/api/student', {
    //     params: {
    //       limit: this.pageSize,
    //       page: page,
    //       search: this.search,
    //       class_id: this.selectedClass,
    //       section_id: this.selectedSection,
    //       session_id: this.selectedSession,
    //       sorter_field: this.sorterField,
    //       sorter_order: this.sorterOrder,
    //       ...this.filters,
    //     },
    //   }).then(({ data }) => {
    //     this.loading = false
    //     this.data = data.data
    //     this.meta = data.meta
    //   })
    // },
    // searchStudents: function(e) {
    //   this.search = e.target.value
    //   this.getStudents(true)
    // },
    // handleCreated: function() {
    //   this.getStudents()
    // },
    handleUpdateTable: function(args) {
      console.log('args', args)
      if (args !== undefined && args !== null && args.length > 0) {
        this.sorterField = args[0]
        this.sorterOrder = args[1]
        this.filters = args[2]
      }
      this.fetchApprovalRequests()
    },
    onShowSizeChange(current, pageSize) {
      this.pageSize = pageSize
      this.current = current
      this.fetchApprovalRequests()
    },
    onChange(current) {
      this.current = current
      this.fetchApprovalRequests()
    },
    getClasses() {
      this.classSpinning = true
      this.$http.get('/api/class', {
        params: {
          session_id: this.selectedSession,
        },
      })
        .then(({ data }) => {
          this.schoolClasses = data.data
          this.classSpinning = false
        })
        .catch(error => {
          console.log(error)
        })
    },
    handleClassSelect(value) {
      this.selectedSection = undefined
      if (value) {
        this.sectionSpinning = true
        this.getClassSections(value)
      }
      this.fetchApprovalRequests()
    },
    getClassSections(value) {
      this.$http.get(`/api/section/class/${value}`, {
        params: {
          session_id: this.selectedSession,
        },
      })
        .then(({ data }) => {
          this.sections = data.data
          this.sectionSpinning = false
        })
        .catch(error => {
          console.log(error)
        })
    },
    handleSectionChange (value) {
      if (value) {
        this.selectedSection = value
        this.fetchApprovalRequests()
      } else {
        this.selectedSection = undefined
        this.fetchApprovalRequests()
      }
    },
    handleSessionChange (value) {
      if (value) {
        this.selectedSession = value
      } else {
        this.selectedSession = this.currentSession
      }
      this.selectedSection = undefined
      this.selectedClass = undefined

      this.getClasses()
      this.fetchApprovalRequests()
    },
    handleDateSelect(date) {
      this.selectedDate = date
      this.fetchApprovalRequests()
    },
    handleStatusChange(value) {
      this.selectedStatus = value
      this.fetchApprovalRequests()
    },
    disabledDate(current) {
      return this.disabledDates.includes(current.format('YYYY-MM-DD')) || current.day() === 0 || current > moment().endOf('day')
    },
    fetchApprovalRequests() {
      this.loading = true
      const params = {
        limit: this.pageSize,
        page: this.current,
        session_id: this.selectedSession,
      }

      if (this.selectedClass !== undefined && this.selectedClass !== null) {
        params.class_id = this.selectedClass
      }

      if (this.selectedSection !== undefined && this.selectedSection !== null) {
        params.section_id = this.selectedSection
      }
      if (this.selectedDate && this.selectedDate.length === 2) {
        params.start_date = this.selectedDate[0].format('YYYY-MM-DD')
        params.end_date = this.selectedDate[1].format('YYYY-MM-DD')
      }
      if (this.selectedStatus !== undefined && this.selectedStatus !== null && this.selectedStatus !== 'All Status') {
        params.status = this.selectedStatus
      }

      this.$http
        .get('/api/approval/all', { params })
        .then(({ data }) => {
          this.data = data.data || []
          this.meta = data.meta || {}
          this.actionRequiredOptions = [...new Set(this.data.map(item => item.action_required))].filter(Boolean)

          console.log('Approval Requests:', this.data)
        })
        .catch((error) => {
          this.$neoNotify.error(error)
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleApprove(id) {
      this.$http
        .post(`api/approval/approve/${id}`)
        .then(() => {
          this.$notification.success({
            message: 'Approved!',
            description: 'The request was successfully approved.',
          })
          this.$refs.approvalTable.closeModal()
          this.fetchApprovalRequests()
        })
        .catch((error) => {
          this.$neoNotify.error(error)
        })
    },
  },
}
</script>
